var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24ZM4.04065 24C4.04065 35.0232 12.9768 43.9594 24 43.9594C35.0232 43.9594 43.9594 35.0232 43.9594 24C43.9594 12.9768 35.0232 4.04065 24 4.04065C12.9768 4.04065 4.04065 12.9768 4.04065 24Z",
    fill: "#ECECEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5006 29.1807H21.4993V33.6796H26.5006V29.1807Z",
    fill: "#CBD6DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5954 32.7148H20.4046C19.8717 32.7148 19.4398 33.1468 19.4398 33.6797C19.4398 34.2125 19.8717 34.6445 20.4046 34.6445H27.5954C28.1282 34.6445 28.5602 34.2125 28.5602 33.6797C28.5602 33.1468 28.1283 32.7148 27.5954 32.7148Z",
    fill: "#AFBBC7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5023 13.3564H14.4977C13.666 13.3564 12.9917 14.0307 12.9917 14.8624V28.9635C12.9917 29.7953 13.666 30.4695 14.4977 30.4695H33.5023C34.334 30.4695 35.0083 29.7952 35.0083 28.9635V14.8624C35.0083 14.0307 34.334 13.3564 33.5023 13.3564Z",
    fill: "#CBD6DC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5356 28.9635V14.8624C16.5356 14.0307 17.2099 13.3564 18.0416 13.3564H14.4977C13.666 13.3564 12.9917 14.0307 12.9917 14.8624V28.9635C12.9917 29.7953 13.666 30.4695 14.4977 30.4695H18.0416C17.2099 30.4696 16.5356 29.7953 16.5356 28.9635Z",
    fill: "#AFBBC7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8017 15.5635H15.1983V27.5313H32.8017V15.5635Z",
    fill: "#2BC5B1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5356 15.5635H15.1983V27.5313H16.5356V15.5635Z",
    fill: "#00AE95"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24 29.6553C24.3619 29.6553 24.6553 29.3619 24.6553 29C24.6553 28.6381 24.3619 28.3447 24 28.3447C23.6381 28.3447 23.3447 28.6381 23.3447 29C23.3447 29.3619 23.6381 29.6553 24 29.6553Z",
    fill: "#465059"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5006 30.4697H21.4993V31.5874H26.5006V30.4697Z",
    fill: "#AFBBC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.6d426d316d91724af9f3aa0c77ad67d6.svg";
export { ForwardRef as ReactComponent };